export enum GradeStatus {
  Correct = 'correct',
  Incorrect = 'incorrect',
  PartiallyCorrect = 'partiallyCorrect',
  Incomplete = 'incomplete',
  Ungraded = 'ungraded',
  Draft = 'draft',
}
